import Select, { MultiValue, SingleValue } from "react-select";
import { FieldProps } from "formik";

// Define a estrutura dos itens de opção esperados por seu componente Select
interface Option {
  label: string;
  value: string;
}

// Os tipos são simplificados para `Option[]` para as opções e `Option | Option[]` para o valor,
// o que é suficiente para uso com o componente Select
interface CustomSelectProps extends FieldProps {
  options: Option[];
  isMulti?: boolean;
  className?: string;
  placeholder?: string;
}

export const CustomSelect = ({
  className,
  placeholder,
  field,
  form,
  options,
  isMulti = false
}: CustomSelectProps) => {
  const onChange = (newValue: MultiValue<Option> | SingleValue<Option>) => {
    if (newValue === null) {
      form.setFieldValue(field.name, isMulti ? [] : '');
    } else {
      form.setFieldValue(
        field.name,
        isMulti
          ? (newValue as Option[]).map((item: Option) => item.value)
          : (newValue as Option).value
      );
    }
  };
  const getValue = () => {
    if (options) {
      return isMulti
        ? options.filter(option => field.value.includes(option.value))
        : options.find(option => option.value === field.value);
    } else {
      return isMulti ? [] : undefined; // Retornando `undefined` para valor único não selecionado
    }
  };

  return (
    <Select
      className={className}
      name={field.name}
      value={getValue()}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      isMulti={isMulti}
    />
  );
};

export default CustomSelect;